export var LinksDisplayName = 'Links';
export var LogoDisplayName = 'Logo';
export var MenuDisplayName = 'Menu';
export var ItemDisplayName = 'Item';
export var LinkDisplayName = 'Link';